import React from 'react';
import { Box, Flex, Text, VStack, Button, Badge } from '@chakra-ui/react';
import { useOrg } from '../../context/OrgContext';

const INTEGRATIONS = [
  { key: 'github', name: 'GitHub Actions', mark: 'GH', markBg: 'gray.100', markFg: 'gray.900', detail: 'Publish test runs from CI', connected: true },
  { key: 'slack', name: 'Slack', mark: 'S', markBg: 'purple.50', markFg: 'purple.700', detail: 'Alert on failed runs and new flaky tests', connected: false },
];

export default function IntegrationsTab() {
  const { canManage } = useOrg();

  return (
    <VStack align="stretch" spacing={3.5}>
      {INTEGRATIONS.map((it) => (
        <Flex
          key={it.key}
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="14px"
          p={4}
          align="center"
          gap={4}
        >
          <Flex boxSize="38px" borderRadius="10px" bg={it.markBg} color={it.markFg} align="center" justify="center" fontWeight="800" fontSize="sm">
            {it.mark}
          </Flex>
          <Box flex="1" minW={0}>
            <Text fontSize="sm" fontWeight="700" color="gray.900">{it.name}</Text>
            <Text fontSize="xs" color="gray.500">{it.detail}</Text>
          </Box>
          <Badge
            textTransform="uppercase"
            fontSize="10px"
            fontWeight="700"
            borderRadius="full"
            px={2.5}
            py={1}
            color={it.connected ? 'status.pass' : 'gray.500'}
            bg={it.connected ? 'status.passBg' : 'gray.100'}
          >
            {it.connected ? 'connected' : 'not connected'}
          </Badge>
          {canManage && (
            <Button size="sm" variant={it.connected ? 'outline' : 'solid'}>
              {it.connected ? 'Configure' : 'Connect'}
            </Button>
          )}
        </Flex>
      ))}
      {!canManage && (
        <Text fontSize="xs" color="gray.400" px={1}>Integrations are managed by Owners and Admins.</Text>
      )}
    </VStack>
  );
}
